import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Table from '../../components/table/table.jsx';
import { useHistory } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization.js';
import { hasModuleAccess } from '../../services/accessService.js';
import { selectUsers, selectUsersFilter } from '../../state/selectors/users.js';
import userManagementService from '../../services/userManagementService.js';
import { AccessLevel, AppModules } from '../../constants/appAccess.js';
import { setLoading } from '../../state/ducks/app.js';
import { Check } from '../../components/view_controls/check.js';
import ToggleButtonSimple from '../../components/buttons/toggle_button_simple.js';
import { getState } from '../../state/store.js';

const UserList = () => {
    const users = useSelector(selectUsers());
    const filter = useSelector(selectUsersFilter());
    const history = useHistory();
    const { t } = useLocalization();
    const currentUserId = getState().app.user.userId;

    useEffect(() => {
        getData();
    }, []);

    const getData = (applyFilter) => {
        applyFilter = applyFilter ? applyFilter : filter;
        userManagementService.getUsersAsync(applyFilter);
    }

    const addUser = () => {
        history.push('/users/addUser');
    }

    const editUser = (user) => {
        history.push('/users/editUser/' + user.applicationUserId);
    }

    const changeUserActive = (user) => {
        setLoading(true);
        setUserActive(user);
    }

    const setUserActive = async (user) => {
        try {
            await userManagementService.changeUserActivityAsync(user.applicationUserId, !user.isActive);
        }
        catch {
        }
        setLoading(false);
    }

    const modelFilter = {
        userName: {
            name: "userName",
            type: "string",
            header: t('UserManagement.userName'),
            value: filter.modelFilter.userName
        },
        roleName: {
            name: "roleName",
            type: "string",
            header: t('UserManagement.roleName'),
            value: filter.modelFilter.roleName
        }
    };

    const Columns = [
        {
            header: "UserManagement.userName",
            name: "userName"
        },
        {
            header: "UserManagement.firstName",
            name: "firstName"
        },
        {
            header: "UserManagement.secondName",
            name: "secondName"
        },
        {
            header: "UserManagement.email",
            name: "email"
        },
        {
            header: "UserManagement.roleName",
            name: "roleName"
        },
        {
            header: "UserManagement.isActive",
            dataType: 'custom',
            name: "isActive",
            render: (item) => {
                const hasAccess = hasModuleAccess(AppModules.UserManagement, AccessLevel.Write);
                return (
                    <>
                        {
                            hasAccess ?
                                <ToggleButtonSimple disabled={currentUserId === item.applicationUserId}
                                value={item.isActive} 
                                onChange={() => changeUserActive(item)}></ToggleButtonSimple>
                                : <Check checked={item.isActive}></Check>
                        }
                    </>
                )
            }
        }
    ];


    return (
        <div>
            <Table settings={{
                columns: Columns,
                items: users,
                itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                isEditable: hasModuleAccess(AppModules.UserManagement, AccessLevel.Write),
                getItemsFunction: getData,
                addItemFunction: hasModuleAccess(AppModules.UserManagement, AccessLevel.Write) ? addUser : undefined,
                editItemFunction: editUser,
                keyField: "applicationUserId"
            }} />
        </div>
    );
}


export default UserList;